function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/** @jsxRuntime classic */

/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useState, useEffect, useImperativeHandle, memo, useCallback } from 'react';
import classNames from 'classnames';
import style from './buttonSelector.style';
/**
 * This component represent a button selector that works like a radio button group, but with button style.
 * @param {Array} data Array with the button selector options.
 * @param {function} onChange Function triggered everytime that the selected button change.
 * @param {*} value Actual value of the button selector.
 * @param {object} containerRef Ref to the button selector container.
 * @param {boolean} disabled Boolean value used to determine if the button selector is enable or disabled.
 * @param {Error} error Error on button selector.
 * @param {boolean} touched Value used to determine if the button selector is touched or not, usually formik.touched is used here.
 * @param {JSON} buttonStyle Custom style for the buttons.
 * @param {string} className Used for the buttons to apply predetermined styles.
 */

const ButtonSelector = /*#__PURE__*/memo(({
  data,
  onChange,
  value = '',
  containerRef = null,
  disabled = false,
  error,
  touched,
  buttonStyle,
  className,
  ...props
}) => {
  const [state, setState] = useState({
    current: '',
    disabled: false
  });
  const changeCurrent = useCallback(current => {
    setState(values => ({ ...values,
      current
    }));

    if (onChange) {
      onChange(current);
    }
  }, [onChange]);
  useEffect(() => {
    setState(values => ({ ...values,
      current: value,
      disabled
    }));
  }, [value, disabled]);
  useImperativeHandle(containerRef, () => ({
    clean() {
      setState(values => ({ ...values,
        current: '',
        disabled: false
      }));
      onChange('');
    }

  }));
  return jsx("div", {
    css: style
  }, data.map(item => jsx("button", _extends({
    id: item.id || item.value,
    key: `${item.text}_${item.value}`,
    disabled: item.disabled !== undefined && item.disabled !== null ? item.disabled : state.disabled,
    className: classNames({
      selected: state.current === item.value,
      error: (error === null || error === void 0 ? void 0 : error.length) > 0 && touched,
      [className]: true
    }),
    style: { ...buttonStyle
    },
    type: "button",
    onClick: () => changeCurrent(item.value)
  }, props), item.text)));
});
export default ButtonSelector;